import { useContext } from 'react';
import MetricsInspectionContext from '../../state/context';
import usePeriods from '../../state/hooks/usePeriods';
import { LBButton } from '@linearb/buzz';
import { useCopyLink } from 'components/hooks/useCopyLink';

const CopyLink = () => {
  const {
    state: {
      isPublic,
      widget,
      filters: { team }
    }
  } = useContext(MetricsInspectionContext);
  const { lastPeriod } = usePeriods();

  const { onClickCopyLink } = useCopyLink();

  return isPublic ? (
    <LBButton
      variant='outline'
      onClick={() => {
        onClickCopyLink({
          widget,
          team,
          lastPeriod
        });
      }}
    >
      Share
    </LBButton>
  ) : (
    <></>
  );
};

export default CopyLink;
